module.exports = __webpack_public_path__ + "img/kv_btn.bb07f30c.png";